"use client";
import {
  CollectionContextProvider,
  CollectionScopedContextProvider
} from "./FMYQNSCK.js";
import {
  createStoreContext
} from "./HKOOKEDE.js";

// src/form/form-context.tsx
var ctx = createStoreContext(
  [CollectionContextProvider],
  [CollectionScopedContextProvider]
);
var useFormContext = ctx.useContext;
var useFormScopedContext = ctx.useScopedContext;
var useFormProviderContext = ctx.useProviderContext;
var FormContextProvider = ctx.ContextProvider;
var FormScopedContextProvider = ctx.ScopedContextProvider;

export {
  useFormContext,
  useFormScopedContext,
  useFormProviderContext,
  FormContextProvider,
  FormScopedContextProvider
};
